'use strict';

module.exports = {
  H264_STREAM_TYPE: 0x1B,
  ADTS_STREAM_TYPE: 0x0F,
  METADATA_STREAM_TYPE: 0x15
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/videojs-contrib-hls/node_modules/mux.js/lib/m2ts/stream-types.js
// module id = 202
// module chunks = 0